import { NavLink, Outlet } from 'react-router-dom'
import { Contact, FileUp, GitMerge, Inbox, LayoutDashboard, Users } from 'lucide-react'
import clsx from 'clsx'

const CRM_TABS = [
  { to: '/lc-crm/dashboard', label: '대시보드', icon: LayoutDashboard },
  { to: '/lc-crm/inbox', label: '접수함', icon: Inbox },
  { to: '/lc-crm/leads', label: '리드', icon: Users },
  { to: '/lc-crm/merge', label: '병합 검토', icon: GitMerge },
  { to: '/lc-crm/import', label: 'Import', icon: FileUp },
] as const

export function LcCrmLayout() {
  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-start gap-3">
        <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary">
          <Contact className="size-5" />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-foreground">LC 가맹 CRM</h1>
          <p className="text-sm text-muted-foreground">
            설명회·가맹 문의 접수부터 계약 전 리드까지 관리합니다.
          </p>
        </div>
      </header>

      <nav aria-label="LC CRM" className="flex gap-6 overflow-x-auto border-b border-border">
        {CRM_TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              clsx(
                'flex min-w-fit items-center gap-2 border-b-2 px-1 py-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
              )
            }
          >
            <tab.icon className="size-4" />
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  )
}
